import React, { useEffect } from "react";
import { Form, Input, Button } from "antd";
import Modal from "components/Modal/Modal";

export default function ChangeEmailModal({ visible, onClose, onSubmit }) {
  const [form] = Form.useForm();

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        onSubmit(values.email);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  useEffect(() => {
    if (!visible) {
      form.resetFields();
    }
  }, [visible]);

  return (
    <Modal
      title="Change Email"
      visible={visible}
      onCancel={onClose}
      onOk={handleOk}
      footer={[
        <Button key="back" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk}>
          Submit
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical" name="change_email_form">
        <Form.Item
          name="email"
          label="Recipient Email"
          rules={[
            {
              type: "email",
              message: "The input is not valid E-mail!",
            },
            {
              required: true,
              message: "Please input a valid E-mail!",
            },
          ]}
        >
          <Input placeholder="Enter new email" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
